"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mapa = void 0;
//import * as loadGoogle.mapsApi from "load-google-maps-api";
var $ = require("jquery");
var config_1 = require("./config");
var ApiService_1 = require("./services/ApiService");
require("../assets/js/maplabel.js");
var _ = require("lodash");
var form_map_layout_1 = require("./form.map-layout");
var Mapa = /** @class */ (function () {
    function Mapa(moduleId) {
        this.surfaceCoordinates = [[]];
        this.areaM2 = [];
        this.polygons = [];
        this.mapLabel = [];
        this.moduleArea = [];
        this.modulesPolygons = [];
        this.modulesPolygonsLayout = [];
        this.maxSurface = 10000;
        this.minSurface = 1;
        this.validAreas = false;
        this._drawingPath = [];
        this._previewPolyline = null;
        this._rubberBandLine = null;
        this._closingPreviewLine = null;
        this._mapClickListener = null;
        this._mapDblClickListener = null;
        this._mapMoveListener = null;
        this._clickDeferTimeout = null;
        this._segmentLabels = [];
        this._rubberBandLabel = null;
        this._closingLabel = null;
        this.moduleId = moduleId;
        this.country = "España";
        this.nAreas = 0;
        this.setEvents();
        this.init();
    }
    Mapa.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.areaM2[0] = 0;
                        this.resizeMap();
                        this.map = new google.maps.Map(document.getElementById("mapa"), {
                            zoom: 7,
                            center: {
                                lat: 41,
                                lng: 2,
                            },
                            mapTypeId: google.maps.MapTypeId.SATELLITE,
                            disableDefaultUI: true,
                            zoomControl: true,
                            tilt: 0,
                        });
                        // Iniciamos el objeto de Google Maps que nos permite obtener los datos de una dirección
                        this.geocoder = new google.maps.Geocoder();
                        // Iniciamos el objeto de Google Maps que nos permite obtener la elevación de un punto
                        this.elevator = new google.maps.ElevationService();
                        this.enableDrawingMode();
                        return [4 /*yield*/, this.getProducts()];
                    case 1:
                        _a.sent();
                        this.mapLayout = new form_map_layout_1.MapLayout(this.product, config_1.config);
                        return [2 /*return*/];
                }
            });
        });
    };
    Mapa.prototype.getProducts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var references, data, product, length_1, width, modules_power_output, flatStructure, inclinationStructure, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        references = [
                            config_1.config.context.flatStructureRef,
                            config_1.config.context.inclinationStructureRef,
                        ];
                        if (!this.moduleId) {
                            references.push(config_1.config.context.moduleRef);
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, ApiService_1.ApiService.getProducts(references, this.moduleId)];
                    case 2:
                        data = _a.sent();
                        product = data.find(function (property) {
                            return property.id === _this.moduleId ||
                                property.reference === config_1.config.context.moduleRef;
                        });
                        if (product) {
                            length_1 = product.properties ? product.properties.length : null;
                            width = product.properties ? product.properties.width : null;
                            modules_power_output = product.properties
                                ? product.properties.modules_power_output
                                : null;
                            this.moduleId = product.id;
                            this.product = {
                                properties: {
                                    length: parseInt(length_1),
                                    width: parseInt(width),
                                    modules_power_output: modules_power_output,
                                },
                            };
                        }
                        flatStructure = data.find(function (property) { return property.reference === config_1.config.context.flatStructureRef; });
                        inclinationStructure = data.find(function (property) {
                            return property.reference === config_1.config.context.inclinationStructureRef;
                        });
                        if (flatStructure)
                            this.flatStructure = flatStructure.id;
                        if (inclinationStructure)
                            this.inclinationStructure = inclinationStructure.id;
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error("Error on get Products", error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Activa el modo de dibujo de polígonos mediante clicks en el mapa.
     * Sustituye al antiguo DrawingManager (eliminado en Google Maps JS API v3.65).
     *
     * Funcionalidades (portadas de app-solar-bpm LayoutMapPolygonDrawSession):
     * - Click: añade un vértice (con defer de 140ms para evitar conflicto con dblclick)
     * - Click en primer vértice: cierra el polígono (snap magnético por proximidad)
     * - Doble-click: cierra el polígono
     * - Rubber-band: línea desde último vértice al cursor
     * - Closing preview: línea punteada desde cursor al primer vértice
     * - Anti auto-intersección: rechaza vértices que cruzarían aristas existentes
     */
    Mapa.prototype.enableDrawingMode = function () {
        var _this = this;
        this.disableDrawingMode();
        this.mapLabel[this.nAreas] = new MapLabel({
            text: "",
            map: this.map,
            fontSize: 20,
            align: "center",
            zIndex: 5,
        });
        this._drawingPath = [];
        this.map.setOptions({ disableDoubleClickZoom: true, draggableCursor: "crosshair" });
        var areaColor = getComputedStyle(document.documentElement).getPropertyValue("--areaColor");
        this._previewPolyline = new google.maps.Polyline({
            map: this.map,
            strokeColor: areaColor,
            strokeWeight: 3,
            strokeOpacity: 0.8,
            clickable: false,
            zIndex: 2,
        });
        this._rubberBandLine = new google.maps.Polyline({
            map: this.map,
            strokeColor: areaColor,
            strokeWeight: 2,
            strokeOpacity: 0.5,
            clickable: false,
            zIndex: 3,
        });
        this._closingPreviewLine = new google.maps.Polyline({
            map: this.map,
            strokeColor: areaColor,
            strokeOpacity: 0,
            strokeWeight: 2,
            clickable: false,
            zIndex: 2,
            icons: [{
                    icon: { path: "M 0,-1 0,1", strokeOpacity: 0.4, strokeColor: areaColor, scale: 3 },
                    offset: "0",
                    repeat: "12px",
                }],
        });
        this._mapClickListener = google.maps.event.addListener(this.map, "click", function (e) {
            _this._cancelClickDefer();
            if (_this._drawingPath.length >= 3 && _this._isNearFirstVertex(e.latLng)) {
                _this.finishDrawing(areaColor);
                return;
            }
            _this._clickDeferTimeout = setTimeout(function () {
                _this._clickDeferTimeout = null;
                if (_this._wouldCrossExistingEdges(e.latLng))
                    return;
                _this._drawingPath.push(e.latLng);
                _this._previewPolyline.setPath(_this._drawingPath);
                _this._addFixedSegmentLabel();
            }, Mapa.CLICK_DEFER_MS);
        });
        this._mapMoveListener = google.maps.event.addListener(this.map, "mousemove", function (e) {
            if (_this._drawingPath.length > 0) {
                var lastVertex = _this._drawingPath[_this._drawingPath.length - 1];
                _this._rubberBandLine.setPath([lastVertex, e.latLng]);
            }
            if (_this._drawingPath.length >= 2) {
                _this._closingPreviewLine.setPath([e.latLng, _this._drawingPath[0]]);
            }
            else {
                _this._closingPreviewLine.setPath([]);
            }
            _this._updatePreviewLabels(e.latLng);
        });
        this._mapDblClickListener = google.maps.event.addListener(this.map, "dblclick", function () {
            _this._cancelClickDefer();
            if (_this._drawingPath.length < 3) {
                _this._drawingPath = [];
                _this._previewPolyline.setPath([]);
                _this._clearAllSegmentLabels();
                return;
            }
            _this.finishDrawing(areaColor);
        });
    };
    Mapa.prototype._cancelClickDefer = function () {
        if (this._clickDeferTimeout) {
            clearTimeout(this._clickDeferTimeout);
            this._clickDeferTimeout = null;
        }
    };
    /**
     * Comprueba si el cursor está cerca del primer vértice (< 10px) para cerrar el polígono.
     * Usa distancia en píxeles (no metros) para que el umbral sea consistente en cualquier zoom.
     */
    Mapa.prototype._isNearFirstVertex = function (cursor) {
        if (this._drawingPath.length < 3)
            return false;
        var firstVertex = this._drawingPath[0];
        var projection = this.map.getProjection();
        if (!projection)
            return false;
        var scale = Math.pow(2, this.map.getZoom());
        var cursorPt = projection.fromLatLngToPoint(cursor);
        var firstPt = projection.fromLatLngToPoint(firstVertex);
        var dx = (cursorPt.x - firstPt.x) * scale;
        var dy = (cursorPt.y - firstPt.y) * scale;
        return Math.sqrt(dx * dx + dy * dy) < 10;
    };
    /**
     * Detecta si añadir un nuevo vértice cruzaría aristas existentes del polígono.
     * Usa el test de intersección propia de segmentos (cross product).
     */
    Mapa.prototype._wouldCrossExistingEdges = function (newVertex) {
        var vertices = this._drawingPath;
        if (vertices.length < 2)
            return false;
        var newLat = newVertex.lat();
        var newLng = newVertex.lng();
        var lastLat = vertices[vertices.length - 1].lat();
        var lastLng = vertices[vertices.length - 1].lng();
        for (var i = 0; i < vertices.length - 2; i++) {
            var aLat = vertices[i].lat();
            var aLng = vertices[i].lng();
            var bLat = vertices[i + 1].lat();
            var bLng = vertices[i + 1].lng();
            if (this._segmentsIntersect(lastLat, lastLng, newLat, newLng, aLat, aLng, bLat, bLng)) {
                return true;
            }
        }
        return false;
    };
    /**
     * Test de intersección propia entre dos segmentos usando cross products.
     * Devuelve true solo si los segmentos se cruzan propiamente (no en endpoints compartidos).
     */
    Mapa.prototype._segmentsIntersect = function (p1x, p1y, p2x, p2y, p3x, p3y, p4x, p4y) {
        var d1 = (p4x - p3x) * (p1y - p3y) - (p4y - p3y) * (p1x - p3x);
        var d2 = (p4x - p3x) * (p2y - p3y) - (p4y - p3y) * (p2x - p3x);
        var d3 = (p2x - p1x) * (p3y - p1y) - (p2y - p1y) * (p3x - p1x);
        var d4 = (p2x - p1x) * (p4y - p1y) - (p2y - p1y) * (p4x - p1x);
        if (((d1 > 0 && d2 < 0) || (d1 < 0 && d2 > 0)) &&
            ((d3 > 0 && d4 < 0) || (d3 < 0 && d4 > 0))) {
            return true;
        }
        return false;
    };
    /**
     * Crea un OverlayView que muestra la distancia en metros en el punto medio de un segmento.
     * Portado de app-solar-bpm: layout-map-draw-segment-labels-overlay.ts
     */
    Mapa.prototype._createSegmentLabel = function (start, end) {
        var segStart = start;
        var segEnd = end;
        var labelEl = null;
        var overlay = new google.maps.OverlayView();
        var drawLabel = function () {
            if (!labelEl)
                return;
            var proj = overlay.getProjection();
            if (!proj)
                return;
            var startPx = proj.fromLatLngToDivPixel(segStart);
            var endPx = proj.fromLatLngToDivPixel(segEnd);
            if (!startPx || !endPx) {
                labelEl.style.display = "none";
                return;
            }
            var dx = endPx.x - startPx.x;
            var dy = endPx.y - startPx.y;
            var len = Math.hypot(dx, dy);
            if (len < 1) {
                labelEl.style.display = "none";
                return;
            }
            var meters = google.maps.geometry.spherical.computeDistanceBetween(segStart, segEnd);
            var angle = (Math.atan2(dy, dx) * 180) / Math.PI;
            if (angle > 90)
                angle -= 180;
            else if (angle < -90)
                angle += 180;
            var offsetPx = 14;
            var offX = (-dy / len) * offsetPx;
            var offY = (dx / len) * offsetPx;
            labelEl.textContent = meters.toFixed(2).replace(".", ",") + "m";
            labelEl.style.display = "block";
            labelEl.style.left = ((startPx.x + endPx.x) / 2 + offX) + "px";
            labelEl.style.top = ((startPx.y + endPx.y) / 2 + offY) + "px";
            labelEl.style.transform = "translate(-50%, -50%) rotate(" + angle + "deg)";
        };
        overlay.onAdd = function () {
            labelEl = document.createElement("div");
            labelEl.style.cssText =
                "position:absolute;color:#fff;font-size:11px;font-weight:600;" +
                    "white-space:nowrap;pointer-events:none;z-index:1000;" +
                    "text-shadow:0 0 4px rgba(0,0,0,.9),0 1px 2px rgba(0,0,0,.9)";
            overlay.getPanes().floatPane.appendChild(labelEl);
            drawLabel();
        };
        overlay.draw = drawLabel;
        overlay.onRemove = function () { labelEl === null || labelEl === void 0 ? void 0 : labelEl.remove(); labelEl = null; };
        return {
            setMap: function (map) { return overlay.setMap(map); },
            update: function (newStart, newEnd) { segStart = newStart; segEnd = newEnd; drawLabel(); },
        };
    };
    /** Anade una label fija para la última arista colocada. */
    Mapa.prototype._addFixedSegmentLabel = function () {
        var path = this._drawingPath;
        if (path.length < 2)
            return;
        var label = this._createSegmentLabel(path[path.length - 2], path[path.length - 1]);
        label.setMap(this.map);
        this._segmentLabels.push(label);
    };
    /** Actualiza las labels de preview (rubber-band + closing) con la posición del cursor. */
    Mapa.prototype._updatePreviewLabels = function (cursorLatLng) {
        var path = this._drawingPath;
        if (path.length > 0) {
            var lastVertex = path[path.length - 1];
            if (!this._rubberBandLabel) {
                this._rubberBandLabel = this._createSegmentLabel(lastVertex, cursorLatLng);
                this._rubberBandLabel.setMap(this.map);
            }
            else {
                this._rubberBandLabel.update(lastVertex, cursorLatLng);
            }
        }
        if (path.length >= 2) {
            if (!this._closingLabel) {
                this._closingLabel = this._createSegmentLabel(cursorLatLng, path[0]);
                this._closingLabel.setMap(this.map);
            }
            else {
                this._closingLabel.update(cursorLatLng, path[0]);
            }
        }
    };
    /** Elimina todas las labels de segmento del mapa. */
    Mapa.prototype._clearAllSegmentLabels = function () {
        this._segmentLabels.forEach(function (l) { return l.setMap(null); });
        this._segmentLabels = [];
        if (this._rubberBandLabel) {
            this._rubberBandLabel.setMap(null);
            this._rubberBandLabel = null;
        }
        if (this._closingLabel) {
            this._closingLabel.setMap(null);
            this._closingLabel = null;
        }
    };
    /**
     * Desactiva el modo de dibujo: elimina listeners y preview.
     */
    Mapa.prototype.disableDrawingMode = function () {
        this._cancelClickDefer();
        if (this._mapClickListener) {
            google.maps.event.removeListener(this._mapClickListener);
            this._mapClickListener = null;
        }
        if (this._mapDblClickListener) {
            google.maps.event.removeListener(this._mapDblClickListener);
            this._mapDblClickListener = null;
        }
        if (this._mapMoveListener) {
            google.maps.event.removeListener(this._mapMoveListener);
            this._mapMoveListener = null;
        }
        if (this._previewPolyline) {
            this._previewPolyline.setMap(null);
            this._previewPolyline = null;
        }
        if (this._rubberBandLine) {
            this._rubberBandLine.setMap(null);
            this._rubberBandLine = null;
        }
        if (this._closingPreviewLine) {
            this._closingPreviewLine.setMap(null);
            this._closingPreviewLine = null;
        }
        this._clearAllSegmentLabels();
        if (this.map) {
            this.map.setOptions({ draggableCursor: null });
        }
        this._drawingPath = [];
    };
    /**
     * Cierra el polígono dibujado, lo crea como google.maps.Polygon editable
     * y ejecuta la misma lógica que el antiguo handler overlaycomplete.
     */
    Mapa.prototype.finishDrawing = function (areaColor) {
        var path = __spreadArrays(this._drawingPath);
        this.disableDrawingMode();
        var polygonId = this.mongoObjectId();
        var polygon = new google.maps.Polygon({
            paths: path,
            fillColor: areaColor,
            strokeColor: areaColor,
            fillOpacity: 0.6,
            strokeWeight: 5,
            clickable: false,
            editable: true,
            zIndex: 1,
            map: this.map,
        });
        polygon.id = polygonId;
        this.onPolygonComplete(polygon);
    };
    /**
     * Procesa un polígono recién dibujado: valida su tamaño, crea el área de
     * módulos, dibuja los módulos y conecta los listeners de edición.
     * Combina la lógica de los antiguos handlers polygoncomplete + overlaycomplete.
     */
    Mapa.prototype.onPolygonComplete = function (polygon) {
        var _this = this;
        if (!this.product || !this.product.properties) {
            console.error("Product not loaded yet. Cannot process polygon.");
            polygon.setMap(null);
            this.enableDrawingMode();
            return;
        }
        $(".map-information").show();
        $(".map-instructions").hide();
        $(".tools").show();
        $(".tools ul").show();
        $(".map-collapse").addClass("vis-mobile");
        if ($(".map-collapse").hasClass("collapsed")) {
            $(".map-collapse").toggleClass("collapsed");
            $(".map-information .user-information").collapse("toggle");
        }
        google.maps.event.addListener(polygon, "dblclick", function (event) {
            if (event.vertex == undefined) {
                return;
            }
            else {
                if (polygon.getPath().getLength() > 3) {
                    _this.removeVertex(polygon, event.vertex);
                }
            }
        });
        this.newShape = polygon;
        var polygonBounds = this.newShape.getPath();
        this.currentSurfaceAzimuth = this.computeAzimuth(polygonBounds);
        var totalSurface = google.maps.geometry.spherical.computeArea(polygonBounds);
        if (totalSurface > this.maxSurface)
            this.showMessageSizeArea(this.newShape, polygonBounds, { overlay: polygon }, "big");
        else if (totalSurface < this.minSurface)
            this.showMessageSizeArea(this.newShape, polygonBounds, { overlay: polygon }, "small");
        else {
            var that_1 = this;
            var newArea_1 = this.createModuleAreaObject(this.newShape);
            this.newShape.id = newArea_1.id;
            this.polygons.push(this.newShape);
            var areaPolygon = _.find(this.polygons, function (p) {
                return p.id == newArea_1.id;
            });
            var layoutData = this.mapLayout.drawModules(true, newArea_1, areaPolygon, this.modulesPolygons, this.polygons, this.moduleArea);
            newArea_1.maxModules = layoutData.maxModules;
            this.totalModules = layoutData.totalModules;
            this.totalPower = layoutData.totalPower;
            this.totalSurface = layoutData.totalSurface;
            this.createModulesObject(newArea_1);
            polygonBounds.id = this.nAreas;
            this.getPathBounds(polygonBounds, this.nAreas);
            this.areaM2[this.nAreas] =
                google.maps.geometry.spherical.computeArea(polygonBounds);
            this.setMapLabel(polygonBounds, polygonBounds.id);
            this.validAreas = true;
            google.maps.event.addListener(polygonBounds, "set_at", function () {
                that_1.actionEditAreaEvent(polygonBounds, "set_at");
            });
            google.maps.event.addListener(polygonBounds, "remove_at", function () {
                that_1.actionEditAreaEvent(polygonBounds, "remove_at");
            });
            google.maps.event.addListener(polygonBounds, "insert_at", function () {
                that_1.actionEditAreaEvent(polygonBounds, "insert_at");
            });
            $("#submitStep2 .send-button").prop("disabled", false);
            if (this.validAreas) {
                this.calculateSavings();
                this.resizeMap();
            }
        }
    };
    /**
     * If area is bigger than 'maxSurface' it show an error message in the middle of the area
     * @param newShape drawn area
     * @param polygonBounds polygon bounds of the area
     * @param polygon polygon to get the map
     * @param size if its big or small area
     */
    Mapa.prototype.showMessageSizeArea = function (newShape, polygonBounds, polygon, size) {
        // newShape.id = this.StringUtils.mongoObjectId();
        this.polygons.push(newShape);
        this.disableDrawingMode();
        var contentString = size == "big"
            ? "<div id='" +
                newShape.id +
                "' class='alertArea'>Àrea demasiado grande, dibuje un àrea menor</div>"
            : "<div id='" +
                newShape.id +
                "' class='alertArea'>Àrea demasiado pequeña, dibuje un àrea mayor</div>";
        var infowindow = new google.maps.InfoWindow({
            content: contentString,
            position: this.getCenterInPolygon(polygonBounds),
        });
        infowindow.open(polygon.overlay.getMap());
        this.setEventInfoWindowArea(infowindow);
        this.validAreas = false;
        $(".add-area").addClass("disabled");
        $("#submitStep2 .send-button").prop("disabled", true);
        if (this.moduleArea.length == 0) {
            $(".resp-inf .unit span:first").text("-");
            $(".resp-inf .kilowatt-max span:first").text("-");
            $(".resp-inf .eur span:first").text("-");
            $(".resp-inf .co2 span:first").text("-");
        }
    };
    /**
     * Set event onclick close window and delete all areas
     * @param infowindow info window when area is too big
     */
    Mapa.prototype.setEventInfoWindowArea = function (infowindow) {
        var _this = this;
        google.maps.event.addListener(infowindow, "domready", function () {
            $(".gm-ui-hover-effect").on("click", function (event) {
                var content = infowindow.getContent();
                var doc = new DOMParser().parseFromString(content.toString(), "text/xml");
                var areaId = doc.getElementsByClassName("alertArea")[0].id;
                _this.removeArea(areaId);
                _this.enableDrawingMode();
                if (_this.moduleArea.length > 0) {
                    _this.validAreas = true;
                    $("#submitStep2 .send-button").prop("disabled", false);
                }
                $(".add-area").removeClass("disabled");
            });
        });
        $(".reset-map-drawings").on("click", function () {
            infowindow.close();
            $(".add-area").removeClass("disabled");
        });
        $("#step2 .map-address-modify button").on("click", function () {
            infowindow.close();
            $(".add-area").removeClass("disabled");
        });
    };
    Mapa.prototype.removeArea = function (areaId) {
        var polygon = _.find(this.polygons, function (obj) { return obj.id === areaId; });
        polygon.setMap(null);
        _.remove(this.polygons, function (obj) { return obj.id === areaId; });
    };
    Mapa.prototype.actionEditAreaEvent = function (polygonBounds, eventType) {
        var _this = this;
        this.getPathBounds(polygonBounds, polygonBounds.id, function (polyShapeArray) {
            _this.moduleArea[polygonBounds.id].polyshapeArray = polyShapeArray;
            var areaPolygon = _.find(_this.polygons, function (polygon) {
                return polygon.id == _this.moduleArea[polygonBounds.id].id;
            });
            areaPolygon.setPath(polygonBounds);
            var modulesRemoved = _.remove(_this.modulesPolygons, function (module) {
                return module.areaId === areaPolygon.id;
            });
            for (var _i = 0, modulesRemoved_1 = modulesRemoved; _i < modulesRemoved_1.length; _i++) {
                var moduleRemoved = modulesRemoved_1[_i];
                moduleRemoved.setMap(null);
            }
            _.remove(_this.modulesPolygonsLayout, function (module) {
                return module.areaId === areaPolygon.id;
            });
            _this.moduleArea[polygonBounds.id].surface =
                google.maps.geometry.spherical.computeArea(polygonBounds);
            var layoutData = _this.mapLayout.drawModules(true, _this.moduleArea[polygonBounds.id], areaPolygon, _this.modulesPolygons, _this.polygons, _this.moduleArea);
            _this.moduleArea[polygonBounds.id].maxModules = layoutData.maxModules;
            _this.totalModules = layoutData.totalModules;
            _this.totalPower = layoutData.totalPower;
            _this.totalSurface = layoutData.totalSurface;
            _this.createModulesObject(_this.moduleArea[polygonBounds.id]);
        });
        this.areaM2[polygonBounds.id] =
            google.maps.geometry.spherical.computeArea(polygonBounds);
        this.setMapLabel(polygonBounds, polygonBounds.id);
        this.calculateSavings();
        if ($(".map-collapse").hasClass("collapsed")) {
            $(".map-collapse").toggleClass("collapsed");
            $(".map-information .user-information").collapse("toggle");
        }
    };
    Mapa.prototype.createModulesObject = function (targetArea) {
        var _this = this;
        this.modulesPolygons.forEach(function (moduleObject) {
            if (moduleObject.areaId === targetArea.id) {
                var boundsArray = [];
                var id = moduleObject.id;
                var paths = moduleObject.getPath();
                for (var j = 0; j < paths.getLength(); j++) {
                    boundsArray.push({
                        lat: paths.getAt(j).lat(),
                        lng: paths.getAt(j).lng(),
                    });
                }
                var layoutModule = {
                    id: id,
                    areaId: targetArea.id,
                    productId: targetArea.moduleId,
                    bounds: boundsArray,
                    active: moduleObject.active,
                };
                _this.modulesPolygonsLayout.push(layoutModule);
            }
        });
    };
    /**
     * Duplicate Module Area Object when create a second area
     */
    Mapa.prototype.duplicateModuleAreaObject = function (newShape, area) {
        var _this = this;
        var polygonBounds = newShape.getPath();
        var length = this.moduleArea.push({
            name: "Area " + (this.moduleArea.length + 1),
            id: newShape.id,
            azimuth: area.azimuth,
            vertical: true,
            south: true,
            surface: google.maps.geometry.spherical.computeArea(polygonBounds),
            surfaceTilt: area.surfaceTilt,
            surfaceAzimuth: area.surfaceAzimuth,
            modulesTilt: area.modulesTilt,
            tilt: area.tilt,
            shades: area.shades,
            rowDistance: area.rowDistance,
            columnDistance: area.columnDistance,
            totalStorage: area.totalStorage,
            activeModules: area.activeModules,
            polyshapeArray: [],
            modulePower: this.product.properties.modules_power_output,
            moduleSurface: (this.product.properties.length / 1000) *
                (this.product.properties.width / 1000),
            moduleId: this.moduleId,
            structureId: parseInt($("#menu li.current").attr("value")) == 0
                ? this.flatStructure
                : this.inclinationStructure,
            moduleMatrixDisposition: "row",
            moduleMatrixHorizontal: 1,
            moduleMatrixVertical: 1,
            maxModules: area.maxModules,
            visible: true,
        });
        polygonBounds.forEach(function (element) {
            _this.moduleArea[length - 1].polyshapeArray.push({
                lat: element.lat(),
                lng: element.lng(),
            });
        });
        return this.moduleArea[length - 1];
    };
    /**
     * Calculates the azimuth based on the longest polygon side
     * @param polygonBounds Polygon vertices
     * @returns Integer tilt of the longest polygon side
     */
    Mapa.prototype.computeAzimuth = function (polygonBounds) {
        var polygonBoundsArray = polygonBounds.getArray();
        var sides = _.map(polygonBoundsArray, function (coords) {
            var nextCoords = _.get(polygonBoundsArray, (_.indexOf(polygonBoundsArray, coords) + 1) % polygonBoundsArray.length);
            var distance = google.maps.geometry.spherical.computeDistanceBetween(coords, nextCoords);
            return distance;
        });
        var longestSideIndex = _.indexOf(sides, _.max(sides));
        var longestSides = _.map([longestSideIndex, (longestSideIndex + 1) % polygonBoundsArray.length], function (index) { return _.get(polygonBoundsArray, index); });
        var angle = google.maps.geometry.spherical.computeHeading(longestSides[0], longestSides[1]);
        var roundAngle = _.round(angle);
        if (roundAngle < 0 && roundAngle > -90) {
            roundAngle = -90 - roundAngle;
        }
        else if (roundAngle > 0 && roundAngle < 90) {
            roundAngle = 90 - roundAngle;
        }
        else if (roundAngle < -90) {
            roundAngle += 90;
            roundAngle *= -1;
        }
        else if (roundAngle > 90) {
            roundAngle -= 90;
            roundAngle *= -1;
        }
        else {
            roundAngle = 0;
        }
        return roundAngle;
    };
    /**
     * Create Module Area Object
     */
    Mapa.prototype.createModuleAreaObject = function (newShape) {
        var _this = this;
        var polygonBounds = newShape.getPath();
        var roundAngle = this.currentSurfaceAzimuth;
        $("#azimuthInput").val(roundAngle);
        if (roundAngle > 0) {
            $(".azimuthValue").text(roundAngle + "ºE");
            if (roundAngle < 10) {
                $(".azimuthValue").css("margin-right", "11px");
                $(".azimuthForm output").css("margin-left", "15px");
            }
            else {
                $(".azimuthValue").css("margin-right", "7px");
                $(".azimuthForm output").css("margin-left", "11px");
            }
        }
        else if (roundAngle < 0) {
            $(".azimuthValue").text(roundAngle + "ºO");
            if (roundAngle > -10) {
                $(".azimuthValue").css("margin-right", "7px");
                $(".azimuthForm output").css("margin-left", "12px");
            }
            else {
                $(".azimuthValue").css("margin-right", "1px");
                $(".azimuthForm output").css("margin-left", "9px");
            }
        }
        else {
            $(".azimuthValue").text(roundAngle + "ºS");
            $(".azimuthForm output").css("margin-left", "15px");
        }
        var length = this.moduleArea.push({
            name: "Area " + (this.moduleArea.length + 1),
            id: newShape.id,
            azimuth: roundAngle,
            vertical: true,
            south: true,
            surface: google.maps.geometry.spherical.computeArea(polygonBounds),
            surfaceTilt: 20,
            surfaceAzimuth: roundAngle,
            modulesTilt: 0,
            tilt: 20,
            shades: 0,
            rowDistance: 0,
            columnDistance: 0,
            totalStorage: 0,
            activeModules: 0,
            polyshapeArray: [],
            modulePower: this.product.properties.modules_power_output,
            moduleSurface: (this.product.properties.length / 1000) *
                (this.product.properties.width / 1000),
            moduleId: this.moduleId,
            structureId: parseInt($("#menu li.current").attr("value")) == 0
                ? this.flatStructure
                : this.inclinationStructure,
            moduleMatrixDisposition: "row",
            moduleMatrixHorizontal: 1,
            moduleMatrixVertical: 1,
            maxModules: 0,
            visible: true,
            smallArea: false,
        });
        polygonBounds.forEach(function (element) {
            _this.moduleArea[length - 1].polyshapeArray.push({
                lat: element.lat(),
                lng: element.lng(),
            });
        });
        return this.moduleArea[length - 1];
    };
    Mapa.prototype.clearListeners = function () {
        this.disableDrawingMode();
    };
    Mapa.prototype.findCodeAddress = function (array, code) {
        return _.find(array, function (item) {
            return (_.findIndex(item.types, function (type) {
                return type === code;
            }) !== -1);
        });
    };
    Mapa.prototype.searchInMap = function (places) {
        this.resizeMap();
        $(".map-instructions").show();
        this.geocodeAddress(places);
    };
    Mapa.prototype.geocodeAddress = function (places) {
        var _this = this;
        this.map.setZoom(28);
        this.map.setMapTypeId(google.maps.MapTypeId.SATELLITE);
        this.map.setCenter(new google.maps.LatLng(places.geometry.location.lat(), places.geometry.location.lng()));
        // Guardamos las coordenadas
        this.coordinates = places.geometry.location;
        // Obtenemos la elevación del punto seleccionado
        this.elevator.getElevationForLocations({
            locations: [
                new google.maps.LatLng(places.geometry.location.lat(), places.geometry.location.lng()),
            ],
        }, function (results, status) {
            _this.elevation = results[0].elevation;
        });
    };
    Mapa.prototype.numberWithPoints = function (x) {
        if (x != undefined) {
            x = Math.floor(x);
            x = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
        else {
            x = 0;
        }
        return x;
    };
    Mapa.prototype.getPathBounds = function (polygonBounds, curPolygon, callback) {
        // guardamos las coordenadas de cada punto del polígono
        this.surfaceCoordinates[curPolygon] = [];
        for (var i = 0; i < polygonBounds.length; i++) {
            this.surfaceCoordinates[curPolygon].push({
                lat: polygonBounds.getAt(i).lat(),
                lng: polygonBounds.getAt(i).lng(),
            });
        }
        if (callback)
            callback(this.surfaceCoordinates[curPolygon]);
    };
    Mapa.prototype.getSurface = function () {
        var floors = Number($("#map-floors").val());
        var surface = this.areaM2[0] * (floors === 0 ? 1 : floors);
        return Math.round(surface);
    };
    Mapa.prototype.saveSurfaceArea = function () {
        var surf = this.getSurface();
        if (surf !== 0) {
            $("#dimensions").val(surf);
        }
    };
    Mapa.prototype.resizeMap = function () {
        var mapElement = document.getElementById("mapa");
        mapElement.style.display = "block";
        mapElement.style.height = window.innerHeight + "px";
        mapElement.style.minHeight =
            document.getElementsByClassName("map-controls")[0].scrollHeight + "px";
        google.maps.event.trigger(this.map, "resize");
    };
    Mapa.prototype.resetMap = function () {
        for (var i = 0; i < this.polygons.length; i++) {
            this.polygons[i].setMap(null);
        }
        this.polygons = [];
        this.disableDrawingMode();
        this.areaM2 = [];
        this.surfaceCoordinates = [[]];
        for (var i = 0; i <= this.nAreas; i++) {
            this.mapLabel[i].set("text", "");
        }
        this.nAreas = 0;
        $(".tools").hide();
        $(".map-collapse").removeClass("vis-mobile");
        $(".map-instructions").show();
        var submitStep2 = document.getElementsByClassName("map-information");
        var mapInstructions = (document.getElementsByClassName("map-instructions"));
        if (submitStep2[0]) {
            submitStep2[0].style.display = "none";
            mapInstructions[0].style.display = "block";
        }
        this.moduleArea = [];
        for (var _i = 0, _a = this.modulesPolygons; _i < _a.length; _i++) {
            var removedModulePolygons = _a[_i];
            removedModulePolygons.setMap(null);
        }
        this.modulesPolygons = [];
        this.modulesPolygonsLayout = [];
        this.enableDrawingMode();
    };
    Mapa.prototype.setEvents = function () {
        var _this = this;
        var that = this;
        $(".reset-map-drawings").on("click", function () {
            $("#menu li").removeClass("current");
            $('#menu li[ value="0"]').addClass("current");
            $(".tiltValue").text("20º");
            $("#azimuthInput").val("0");
            $("#azimuthOutput").text("0");
            $(".azimuthValue").text("0ºS");
            $;
            _this.resetMap();
            $(".reset-map-drawings").attr("data-i18n", "[title]step2.DELETE_AREA");
            $(".reset-map-drawings span").attr("data-i18n", "step2.DELETE_AREA");
            $("#step2").localize();
        });
        config_1.config.showInclination
            ? $(".straight-roof").on("click", function () {
                if ($(".straight-roof").hasClass("selected")) {
                    $(".straight-roof").removeClass("selected");
                    $(".dropdown-tilt-container").css("display", "none");
                    $(".tiltValue").css("color", "var(--mainColor)");
                }
                else {
                    $(".straight-roof").addClass("selected");
                    $(".dropdown-tilt-container").css("display", "inline-block");
                    $(".tiltValue").css("color", "white");
                    if (screen.width <= 480) {
                        $(".dropdown-azimuth-container").css("display", "none");
                        $(".sloped-roof").removeClass("selected");
                    }
                }
            })
            : $(".straight-roof").css("display", "none");
        $("#azimuthInput").on("change", function () {
            $(".dropdown-azimuth-container").css("display", "none");
            that.calculateRecommend(that.moduleArea[0].azimuth, that.moduleArea[0].tilt, that.coordinates.lat(), that.coordinates.lng(), parseInt(that.moduleArea[0].modulePower), parseInt(that.offer.powerPlantData.supplyPoint.totalConsumption));
            that.calculateSavings();
        });
        config_1.config.showOrientation
            ? $(".sloped-roof").on("click", function () {
                if ($(".sloped-roof").hasClass("selected")) {
                    $(".sloped-roof").removeClass("selected");
                    $(".dropdown-azimuth-container").css("display", "none");
                    $(".azimuthValue").css("color", "var(--mainColor)");
                }
                else {
                    $(".sloped-roof").addClass("selected");
                    $(".dropdown-azimuth-container").css("display", "inline-block");
                    $(".azimuthValue").css("color", "white");
                    if (screen.width <= 480) {
                        $(".dropdown-tilt-container").css("display", "none");
                        $(".straight-roof").removeClass("selected");
                    }
                }
            })
            : $(".sloped-roof").css("display", "none");
        if (!config_1.config.showCalculations)
            $(".calculations").css("display", "none");
        $("#menu li").click(function () {
            var data = {};
            var $this = $(this);
            $("ul li.current").removeClass("current");
            $this.closest("li").addClass("current");
            $(".tiltValue").text($this.attr("value") + "º");
            var value = parseInt($this.attr("value"));
            var name = $this.attr("name");
            data = that.calculateTiltAzimuth(name, value);
            that.reDrawModules(data);
            that.calculateRecommend(that.moduleArea[0].azimuth, that.moduleArea[0].tilt, that.coordinates.lat(), that.coordinates.lng(), parseInt(that.moduleArea[0].modulePower), parseInt(that.offer.powerPlantData.supplyPoint.totalConsumption));
            that.calculateSavings();
        });
        $("#azimuthInput").on("input", function () {
            var cardinal;
            var name;
            var data = {};
            var $this = $(this);
            var value = parseInt($this.val());
            name = $("#azimuthInput").attr("name");
            data = that.calculateTiltAzimuth(name, value);
            that.reDrawModules(data);
            if (value > 0) {
                cardinal = "E";
                if (value < 10) {
                    $(".azimuthValue").css("margin-right", "11px");
                    $(".azimuthForm output").css("margin-left", "15px");
                }
                else {
                    $(".azimuthValue").css("margin-right", "7px");
                    $(".azimuthForm output").css("margin-left", "11px");
                }
            }
            else {
                if (value == 0) {
                    cardinal = "S";
                    $(".azimuthForm output").css("margin-left", "15px");
                }
                else {
                    if (value > -10) {
                        $(".azimuthValue").css("margin-right", "7px");
                        $(".azimuthForm output").css("margin-left", "12px");
                    }
                    else {
                        $(".azimuthValue").css("margin-right", "1px");
                        $(".azimuthForm output").css("margin-left", "9px");
                    }
                    cardinal = "O";
                }
            }
            $(".azimuthValue").text($this.val() + "º" + cardinal);
        });
        $(".add-area").on("click", function () {
            _this.nAreas += 1;
            if (_this.nAreas == 1) {
                $(".reset-map-drawings").attr("data-i18n", "[title]step2.DELETE_AREAS");
                $(".reset-map-drawings span").attr("data-i18n", "step2.DELETE_AREAS");
                $("#step2").localize();
            }
            $(".tools ul").hide();
            _this.enableDrawingMode();
        });
        $(".map-collapse").on("click", function () {
            $(this).toggleClass("collapsed");
            $(".map-information .user-information").collapse("toggle");
        });
        $(".close-information").on("click", function () {
            $(".map-instructions").hide();
        });
    };
    Mapa.prototype.calculateTiltAzimuth = function (name, value) {
        var surfaceTilt;
        var modulesTilt;
        var tilt;
        var surfaceAzimuth;
        var azimuth;
        switch (name) {
            case "tilt":
                surfaceTilt = value;
                if (value == 0) {
                    modulesTilt = 20;
                }
                else {
                    modulesTilt = 0;
                }
                tilt = modulesTilt + surfaceTilt;
                break;
            case "azimuth":
                this.currentSurfaceAzimuth = value;
                surfaceTilt = parseInt($("#menu li.current").attr("value"));
                break;
        }
        surfaceAzimuth = this.currentSurfaceAzimuth;
        azimuth = surfaceAzimuth;
        return {
            surfaceTilt: surfaceTilt,
            modulesTilt: modulesTilt,
            tilt: tilt,
            surfaceAzimuth: surfaceAzimuth,
            azimuth: azimuth,
        };
    };
    /**
     * Calculate the module row distance separation
     * @param area Target module area
     */
    Mapa.prototype.getDistanceModules = function (area) {
        /** Module length */
        var L = this.product.properties.length / 1000;
        /** Module tilt */
        var B = area.south
            ? area.modulesTilt + area.surfaceTilt
            : area.modulesTilt;
        /** Area surface tilt */
        var i = area.surfaceTilt;
        /** Solar declination degrees  */
        var solarDeclination = -23.45;
        /** PowerPlant area latitude*/
        var lat = area.polyshapeArray[0].lat;
        /** Solar height degrees*/
        var h = 90 - lat + solarDeclination;
        /** Module projection above the surface */
        var d2 = L * Math.cos(this.degreesToRadians(area.south ? B - i : B + i));
        /** Module row distance*/
        var d1 = L *
            (Math.sin(this.degreesToRadians(area.south ? B - i : B + i)) /
                Math.tan(this.degreesToRadians(area.south ? h + i : h - i))) *
            area.moduleMatrixVertical;
        /** Row distance form the beggining of the module*/
        var d = d1 + d2;
        return d1;
    };
    Mapa.prototype.reDrawModules = function (data) {
        for (var _i = 0, _a = this.modulesPolygons; _i < _a.length; _i++) {
            var moduleRemoved = _a[_i];
            moduleRemoved.setMap(null);
        }
        this.modulesPolygons = [];
        this.modulesPolygonsLayout = [];
        for (var _b = 0, _c = this.moduleArea; _b < _c.length; _b++) {
            var moduleArea = _c[_b];
            moduleArea.surfaceTilt = data.surfaceTilt;
            moduleArea.modulesTilt =
                data.modulesTilt || data.modulesTilt == 0
                    ? data.modulesTilt
                    : moduleArea.modulesTilt;
            moduleArea.tilt = moduleArea.surfaceTilt + moduleArea.modulesTilt;
            moduleArea.surfaceAzimuth = data.surfaceAzimuth;
            moduleArea.azimuth = data.azimuth;
            moduleArea.structureId =
                $("#menu li.current").attr("value") == 0
                    ? this.flatStructure
                    : this.inclinationStructure;
            var areaPolygon = _.find(this.polygons, function (polygon) {
                return polygon.id == moduleArea.id;
            });
            moduleArea.columnDistance = this.getDistanceModules(moduleArea);
            var layoutData = this.mapLayout.drawModules(true, moduleArea, areaPolygon, this.modulesPolygons, this.polygons, this.moduleArea);
            moduleArea.maxModules = layoutData.maxModules;
            this.totalModules = layoutData.totalModules;
            this.totalPower = layoutData.totalPower;
            this.totalSurface = layoutData.totalSurface;
            this.createModulesObject(moduleArea);
        }
    };
    Mapa.prototype.removeVertex = function (poly, vertex) {
        var path = poly.getPath();
        path.removeAt(vertex);
    };
    Mapa.prototype.getStaticMap = function (surfaceCoordinates) {
        var url = "https://maps.googleapis.com/maps/api/staticmap?";
        url += "key=AIzaSyBZO6984SQ0MRqg4sXTERCFObTQz9fHYtE";
        if (this.areaM2.reduce(function (a, b) {
            return a + b;
        }, 0) < 400) {
            url += "&zoom=19";
        }
        else if (this.areaM2.reduce(function (a, b) {
            return a + b;
        }, 0) < 1500) {
            url += "&zoom=18";
        }
        else {
            url += "&zoom=17";
        }
        url += "&size=360x130";
        url += "&maptype=satellite";
        url += "&sensor=false";
        //url += '&path=';
        for (var i = 0; i < surfaceCoordinates.length; i++) {
            url += "&path=color:0x017ebaff|weight:2|fillcolor:0x86dcfb80|";
            for (var j = 0; j < surfaceCoordinates[i].length; j++) {
                if (j != 0)
                    url += "|";
                url +=
                    surfaceCoordinates[i][j].lat + "," + surfaceCoordinates[i][j].lng;
            }
            url +=
                "|" + surfaceCoordinates[i][0].lat + "," + surfaceCoordinates[i][0].lng;
        }
        document.getElementById("imgMapa").setAttribute("src", url);
        //http://maps.googleapis.com/maps/api/staticmap?center=33.402285,-111.94271500000002&zoom=20&size=600x600&maptype=satellite&sensor=false&path=color%3ared%7Cweight:1%7Cfill%3awhite%7C33.4022475,-111.9426775%7C33.4022475,-111.9427525%7C33.4023225,-111.9427525%7C33.4023225,-111.9426775%7C33.4022475,-111.9426775
    };
    Mapa.prototype.showCalculateSavings = function (response) {
        var num_fix;
        if (response.power / 1000 < 10)
            num_fix = 2;
        else
            num_fix = 0;
        $("#step2 .user-information .unit span:first").text((response.power / 1000).toFixed(num_fix).replace(".", ","));
        $(".power-installed").text((response.power / 1000).toFixed(num_fix).replace(".", ","));
        $("#step2 .user-information .kilowatt-max span:first").text(this.numberWithPoints(response.production));
        $("#step2 .user-information .eur span:first").text(this.numberWithPoints(response.annualSavings));
        $("#step2 .user-information .co2 span:first").text(this.numberWithPoints(response.estimatePrice));
        $("#step3 .unit span:first").text((response.power / 1000).toFixed(num_fix).replace(".", ","));
        $("#step3 .kilowatt-max span:first").text(this.numberWithPoints(response.production));
        $("#step3 .eur span:first").text(this.numberWithPoints(response.annualSavings));
        $("#step3 .co2 span:first").text(this.numberWithPoints(response.estimatePrice));
        this.waitingResponse = false;
        if (!this.waitingResponse) {
            $(".spinner").hide();
            $(".resp-inf").show();
        }
        // this.validatePowerPlant(
        //   response.production,
        //   this.offer.powerPlantData.supplyPoint.totalConsumption
        // );
    };
    Mapa.prototype.setMapLabel = function (polygonBounds, num) {
        this.mapLabel[num].set("position", this.getCenterInPolygon(polygonBounds));
        this.mapLabel[num].set("text", this.numberWithPoints(this.areaM2[num]) + " m2");
    };
    /**
     * Returns the number of active modules in one area
     * @param layoutModules powerplant layout
     * @param area powerplant area
     * @returns number of active modules or 0
     */
    Mapa.prototype.getNumberActiveModulesByArea = function (layoutModules, area) {
        var numberModulesByArea = _.countBy(layoutModules, function (obj) {
            return obj.areaId === area.id && obj.active === true;
        });
        return (numberModulesByArea.true *
            area.moduleMatrixHorizontal *
            area.moduleMatrixVertical || 0);
    };
    /**
     * Parse data to send layoutData with the moduleArea on calculate Savings
     * @param layout powerplant layout
     */
    Mapa.prototype.parseDataModuleArea = function (layout) {
        var data = [];
        for (var _i = 0, _a = layout.moduleArea; _i < _a.length; _i++) {
            var area = _a[_i];
            var totalActiveModules = this.getNumberActiveModulesByArea(layout.modules, area);
            data.push({
                moduleId: area.moduleId,
                structureId: area.structureId,
                modulePower: area.modulePower,
                activeModules: area.activeModules,
                totalActiveModules: totalActiveModules,
            });
        }
        return { moduleArea: data };
    };
    Mapa.prototype.getCenterInPolygon = function (polygonBounds) {
        var bounds = new google.maps.LatLngBounds();
        for (var i = 0; i < polygonBounds.length; i++) {
            bounds.extend(polygonBounds.getAt(i));
        }
        bounds.extend(polygonBounds.getAt(polygonBounds.length - 1));
        var movemaplat = bounds.getCenter().lat();
        var movemaplng = bounds.getCenter().lng();
        var myLatlng = new google.maps.LatLng(movemaplat, movemaplng);
        return myLatlng;
    };
    Mapa.prototype.calculateSavings = function () {
        return __awaiter(this, void 0, void 0, function () {
            var that, params, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waitingResponse = true;
                        if (this.waitingResponse) {
                            $(".spinner").show();
                            $(".resp-inf").hide();
                        }
                        that = this;
                        params = {
                            data: JSON.parse(JSON.stringify(this.offer)),
                            channelId: this.offer.channelId,
                            templateCode: config_1.config.context.templateCode,
                        };
                        params.data.tariff = this.offer.powerPlantData.supplyPoint.tariffName;
                        params.data.contractedPower =
                            this.offer.powerPlantData.supplyPoint.contractedPower;
                        params.data.slopedRoof = 0;
                        params.data.surface = this.areaM2.reduce(function (a, b) {
                            return a + b;
                        }, 0);
                        params.data.coordinates = {
                            lat: this.coordinates.lat(),
                            lng: this.coordinates.lng(),
                        };
                        params.data.elevation = this.elevation;
                        params.data.power = this.totalPower;
                        params.data.modulesNumber = this.totalModules;
                        params.data.powerPerModule = this.totalPower / this.totalModules;
                        params.data.layoutData = this.parseDataModuleArea({
                            modules: this.modulesPolygonsLayout,
                            moduleArea: this.moduleArea,
                        });
                        params.data.tilt = this.moduleArea[0].tilt;
                        params.data.azimuth = this.moduleArea[0].azimuth;
                        return [4 /*yield*/, ApiService_1.ApiService.getEstimatedSavings(params)];
                    case 1:
                        response = _a.sent();
                        if (response) {
                            this.estimatedSavingsId = response.id;
                            this.showCalculateSavings(response);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Check if production is greater than consumption * 40% and show a message alert.
     * @param production estimated Savings production
     * @param totalConsumption total consumption entered by the client.
     */
    Mapa.prototype.validatePowerPlant = function (production, totalConsumption) {
        if (production && totalConsumption) {
            if (production > parseFloat(totalConsumption) * 0.4) {
                $("#modalPowerPlantError").modal("show");
            }
        }
    };
    /**
     * Javascript ObjectId generator
     * @returns A mongo id with the current time
     */
    Mapa.prototype.mongoObjectId = function () {
        var timestamp = ((new Date().getTime() / 1000) | 0).toString(16);
        return (timestamp +
            "xxxxxxxxxxxxxxxx"
                .replace(/[x]/g, function () {
                return ((Math.random() * 16) | 0).toString(16);
            })
                .toLowerCase());
    };
    /**
     * Convert degrees to radians
     * @param degrees Input degrees to convert
     */
    Mapa.prototype.degreesToRadians = function (degrees) {
        return (degrees * Math.PI) / 180;
    };
    Mapa.prototype.calculateRecommend = function (azimuth, tilt, lat, lon, modulesPower, totalConsumption) {
        return __awaiter(this, void 0, void 0, function () {
            var params, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!config_1.config.showRecommender) return [3 /*break*/, 2];
                        params = {
                            azimuth: azimuth || config_1.config.context.defaultModulesAzimuth,
                            tilt: tilt || config_1.config.context.defaultModulesTilt,
                            lat: lat,
                            lon: lon,
                            modulesPower: modulesPower,
                            totalConsumption: totalConsumption,
                        };
                        return [4 /*yield*/, ApiService_1.ApiService.getRecommendation(params)];
                    case 1:
                        response = _a.sent();
                        if (response && response.layoutTotalPower) {
                            $("#step2 .recommender").css("display", "flex");
                            $("#step2 .recommenderValue").text((response.layoutTotalPower / 1000).toFixed(2).replace(".", ","));
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        $("#step2 .recommender").css("display", "none");
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Mapa.CLICK_DEFER_MS = 140;
    return Mapa;
}());
exports.Mapa = Mapa;
